AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Views", "Focus");

AoPS.Alcumus.Views.Focus = (function (AlcVFocus) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Modal = AoPS.Ui.Modal;
	var Rogb = AoPS.Rogb;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	var AlcVCat = AoPS.Alcumus.Views.Cat;
	// Optional and allowed to load before or after this file
	// AoPS.Alcumus.Debug;

	AlcVFocus.MainPanel = AlcVBase.BaseView.extend({
		// Set small_panel to true in options to use a smaller version of the panel,
		// often needed when embedding Alcumus. Set bar_only to true to only render
		// the progress bar, without any click behavior.
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-focus-panel");

			this.small_panel = !!options.small_panel;
			this.bar_only = !!options.bar_only;
			this.restrict_parent_to = options.restrict_parent_to;
			this.setFocusAdvancedFrom();

			this.full = options.full !== false;

			this.progress_bar = new Rogb.TopicProgressBar({
				use_inset: true,
				show_name: this.small_panel ? "above" : "none",
				show_percent: true,
				use_name_tooltip: !!this.small_panel,
			});
			this.addSubviewToLocation(this.progress_bar, "@progress_bar");

			var new_focus_events =
				"show_problem change:focus_topic change:focus_parent change:is_tutorial_active";
			this.listenTo(this.model, new_focus_events, function () {
				// TODO - all we need to do is reset 'focus advanced from' fields
				// after user changes the focus manually. This works now, but
				// we are depending on advanced_focus happening after the
				// focus_topic/focus_parent change events do. Make more stable?
				this.setFocusAdvancedFrom();
				this.displayNewFocus();
				this.render();
			});
			this.listenTo(
				this.model,
				"advanced_focus",
				function (original_topic, original_parent) {
					this.setFocusAdvancedFrom(original_topic, original_parent);
					this.render();
				}
			);

			this.displayNewFocus();
			this.render();
		},

		events: {
			"click h1": "onEdit",
			"click .aops-rogb-topic-container": "onEdit",
			"click .alc--change-button": "onEdit",
			"click .alc-small-stats": "onDebugBar",
		},

		onEdit: function () {
			if (this.bar_only) {
				return;
			}
			this.stop_change_flashing = true;

			if (!this.edit_window) {
				this.edit_window = new AlcVFocus.EditorWindow({
					model: this.model,
					restrict_parent_to: this.restrict_parent_to,
				});
			}
			this.edit_window.setFocusAdvancedFrom(
				this.advanced_from_topic,
				this.advanced_from_parent
			);

			this.edit_window.show();

			if (
				this.model.get("is_tutorial_active") &&
				!this.edit_window.is_tutorial
			) {
				// Tutorial is over
				this.model.set("is_tutorial_active", false);
			}
		},

		onDebugBar: function () {
			var AlcDebug = AoPS.Alcumus.Debug;
			AlcDebug && AlcDebug.tweakBarProgress(this.progress_bar.progress_bar);
		},

		// Set the focus that Alcumus advanced us from by the last problem. Pass
		// empty arguments to clear this value. This does not render automatically.
		setFocusAdvancedFrom: function (topic_model, parent_model) {
			this.advanced_from_topic = topic_model;
			this.advanced_from_parent = parent_model;
		},

		displayNewFocus: function () {
			if (this.focus_topic) {
				// Have to be careful; focus_topic and model could be equal, so
				// we need to be a bit more specific in these stopListening calls.
				this.stopListening(this.focus_topic, "change");
				this.stopListening(this.focus_topic.get("problem_stats"), "change");
			}

			this.focus_topic = this.model.get("focus_topic");

			if (this.focus_topic) {
				this.listenTo(this.focus_topic, "change", this.render);
				this.listenTo(
					this.focus_topic.get("problem_stats"),
					"change",
					this.render
				);
			}
		},

		shouldShowTopicBar: function () {
			if (!this.full) {
				return true;
			}
			if (!this.focus_topic) {
				return false;
			}
			return (
				this.focus_topic.model_type === "topic" &&
				!this.model.get("is_tutorial_active")
			);
		},

		flashChangeButton: function () {
			if (!this.model.get("is_tutorial_active")) {
				return;
			}

			var anim_time = 600;
			var period = 1500;
			var flash_color = "#F00";

			var button = this.$(".alc--change-button");
			var orig_color = button.css("color");
			function flash() {
				button.animate({color: flash_color}, anim_time);
			}
			function unflash() {
				button.animate({color: orig_color}, anim_time);
			}

			var doIteration = _.bind(function () {
				// Make sure we're still in the DOM, still in the
				// tutorial, and that the user hasn't clicked the button.
				if (
					!button.width() ||
					!this.model.get("is_tutorial_active") ||
					this.stop_change_flashing
				) {
					return;
				}

				flash();
				setTimeout(unflash, anim_time + 10);
				setTimeout(doIteration, period);
			}, this);

			setTimeout(function () {
				// Usually takes a little while to get in the DOM, so recompute
				// the orig_color.
				orig_color = button.css("color");
				doIteration();
			}, 100);
		},

		getContext: function () {
			if (
				!this.hasOwnProperty("focus_topic") ||
				_.isUndefined(this.focus_topic)
			) {
				return {};
			}

			var name = this.focus_topic.get("name");
			var stats = this.focus_topic.get("problem_stats");
			var is_tutorial_active = this.model.get("is_tutorial_active");

			// TODO: make generic js methods for computing this kind of thing
			if (is_tutorial_active) {
				name = "";
			} else if (this.focus_topic.model_type === "subject") {
				name = "All Topics in " + this.focus_topic.get("name");
			} else if (this.focus_topic.model_type === "user") {
				name = "All Topics";
			}

			return {
				small_panel: this.small_panel,
				bar_only: this.bar_only,
				show_topic_bar: this.shouldShowTopicBar(),
				show_name: !this.small_panel && name.length,
				tutorial: is_tutorial_active,
				is_advanced: !!this.advanced_from_topic,

				name: name,
				correct: stats.get("correct"),
				total: stats.get("total"),
				full: this.full,
			};
		},

		postRender: function () {
			if (this.shouldShowTopicBar()) {
				this.progress_bar.setModel(this.focus_topic);
				this.progress_bar.render();
				this.progress_bar.$el.show();
			} else {
				this.progress_bar.$el.hide();
			}

			if (this.advanced_from_topic) {
				this.$("h1").first().addClass(this.progress_bar.getBarColorClass());
			}

			if (this.model.get("is_tutorial_active")) {
				setTimeout(_.bind(this.flashChangeButton, this), 20000);
			}
		},

		onRemoveFromPage: function () {
			// Make sure the panel is updated the next time we come back.
			this.render();
		},
	});

	// This view has two attributes, parent_model and topic_model, tracking
	// the current selection. Uses same format as focus_parent, focus_topic
	// in the user model.
	AlcVFocus.EditorWindow = AlcVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("alc-tpl-focus-edit-window");

			this.restrict_parent_to = options.restrict_parent_to;

			// This is a modal view; we assume nothing will be done with it until
			// show is called, so we are not rendering in initialize.
		},

		createDropdownSubview: function () {
			this.dropdown = new AlcVCat.Dropdown({
				model: this.model,
				exclude_all: !this.is_tutorial && this.is_tutorial_orig,
				is_tutorial: this.is_tutorial,
			});

			var init_parent = this.parent_model;
			if (!init_parent) {
				init_parent = this.is_tutorial
					? this.model
					: this.model.get("focus_parent");
			}
			this.dropdown.selectModel(init_parent);

			this.clearLocation("@dropdown");
			this.listenTo(this.dropdown, "select", this.onDropdownSelect);
			this.addSubviewToLocation(this.dropdown, "@dropdown");
			if (this.restrict_parent_to) {
				this.dropdown.$el.hide();
			}

			return this.dropdown;
		},

		show: function () {
			this.is_tutorial =
				this.model.get("is_tutorial_active") && this.model.useFullTutorial();
			this.is_tutorial_orig = this.is_tutorial;
			this.createDropdownSubview();

			this.resetSelection();
			this.render();

			this.$el.showModal({
				onClose: _.bind(this.resetSelection, this),
			});
		},

		// Set the focus that Alcumus advanced us from by the last problem. Used
		// to show an "old focus" line in the dialog.
		setFocusAdvancedFrom: function (topic_model, parent_model) {
			if (this.restrict_parent_to && this.restrict_parent_to !== parent_model) {
				return;
			}

			this.advanced_from_topic = topic_model;
			this.advanced_from_parent = parent_model;
			this.$el.toggleClass("alc--advanced", !!topic_model);
		},

		setShownParentModel: function (parent_model) {
			parent_model = this.restrict_parent_to || parent_model;
			if (this.parent_model === parent_model) {
				return false; // No change needed
			}
			this.parent_model = parent_model;
			this.dropdown.selectModel(parent_model);

			delete this.topic_model;
			if (parent_model === this.model.get("focus_parent")) {
				this.topic_model = this.model.get("focus_topic");
			} else if (parent_model === this.model) {
				// All topics in all subjects
				this.topic_model = parent_model;
			}

			this.showTable(parent_model);
			return true;
		},

		resetSelection: function () {
			delete this.parent_model;
			this.setShownParentModel(
				this.is_tutorial ? this.model : this.model.get("focus_parent")
			);
			// setShownParentModel will also reset topic_model
		},

		showTable: function () {
			var parent_model = this.parent_model;
			// View property that maps model cids to table views, used as a cache.
			this.topic_tables = this.topic_tables || {};

			var curr_table = this.topic_tables[parent_model.cid];
			if (!curr_table && parent_model.model_type === "user") {
				curr_table = new AlcVFocus.EditorAllDisplay({
					model: parent_model,
				});
				this.topic_tables[parent_model.cid] = curr_table;
			} else if (!curr_table) {
				curr_table = new AlcVCat.ProgressTable({
					parent_model: parent_model,
					row_models: parent_model.get("topics").models,
					left_column_header: "Topics",
					show_class_dates:
						parent_model.model_type === "class" &&
						!parent_model.get("is_self_paced"),
					show_all_option:
						!this.is_tutorial_orig && parent_model.model_type === "subject",
					table_type: "select",
				});
				this.topic_tables[parent_model.cid] = curr_table;
				this.listenTo(curr_table, "select", this.onRowSelect);
			}

			if (curr_table.selectModel) {
				curr_table.selectModel(this.topic_model);
			}

			// Second parameter true so that we don't close any previously made tables.
			this.clearLocation("@progress_table", true);
			this.addSubviewToLocation(curr_table, "@progress_table");
		},

		// Helper for updateDisplays. Pass the jQuery element whose contents are
		// a rendering of alc-tpl-focus-value-message and the topic/parent models that
		// the focus should be set to after a click.
		// TODO: still as hacky as when I did this mangling in the log...
		addDisplayLink: function (display, topic_model, parent_model) {
			var onTextElClick = _.bind(
				this.onSetFocus,
				this,
				topic_model,
				parent_model
			);

			display.find(".alc-topic-name").each(function () {
				var new_el = $("<a></a>");
				new_el.addClass("alc-topic-name alc-pointer");
				new_el.text($(this).text());
				new_el.attr("title", "Click here to change your focus to this topic.");
				new_el.click(onTextElClick);
				$(this).replaceWith(new_el);
			});
		},

		// Compute the recommendation portion of the tutorial/welcome message.
		getTutorialRecommendation: function () {
			var classes = this.model.get("classes");
			var tpl = compileTemplate("#alc-cms-welcome-focus-recommendation");
			return tpl({
				num_classes: classes.length,
				first_class_name: classes.length && classes.at(0).get("name"),
			});
		},

		updateDisplays: function (options) {
			options = options || {};

			var old_topic = this.model.get("focus_topic");
			var old_parent = this.model.get("focus_parent");
			var orig_topic = this.advanced_from_topic;
			var orig_parent = this.advanced_from_parent;
			var new_parent = this.parent_model;
			var new_topic = this.topic_model;

			var old_display = this.$(".alc-current-focus");
			var orig_display = this.$(".alc-original-focus");
			var new_display = this.$(".alc-new-focus");
			var buttons = this.$(".alc-set-focus-button, .alc-cancel-button");
			var play_button = this.$(".alc-play-button");

			// Template for both old and new displays
			var focusValueTpl = compileTemplate("#alc-tpl-focus-value-message");
			var tutorialFocusSetTpl = compileTemplate("#alc-cms-welcome-focus-set");

			// Special case: tutorial
			if (options.end_of_tutorial) {
				old_display.html(
					tutorialFocusSetTpl({
						new_topic_name: new_topic.get("name"),
					})
				);
				orig_display.html("");
				new_display.html("&nbsp;");
				buttons.hide();
				play_button.css("display", "inline-block");
				return;
			} else if (this.is_tutorial && new_parent.model_type === "user") {
				old_display.html(this.getTutorialRecommendation());
				orig_display.html("");
				new_display.html("&nbsp;");
				buttons.hide();
				play_button.hide();
				return;
			} else {
				play_button.hide();
			}

			// Update the old focus display
			old_display.html(
				focusValueTpl({
					focus_parent: old_parent.get("name"),
					focus_parent_type: old_parent.model_type,
					focus_topic: old_topic.get("name"),
					focus_topic_type: old_topic.model_type,
				})
			);

			// Update the original focus display, if applicable
			if (orig_topic) {
				orig_display.html(
					focusValueTpl({
						advanced_from: true,
						focus_parent: orig_parent.get("name"),
						focus_parent_type: orig_parent.model_type,
						focus_topic: orig_topic.get("name"),
						focus_topic_type: orig_topic.model_type,
					})
				);
				this.addDisplayLink(orig_display, orig_topic, orig_parent);
			}

			// Update the new focus display
			var no_change = old_topic === new_topic && old_parent === new_parent;
			if (!new_topic || no_change) {
				// Either nothing selected or wouldn't be a change; hide bottom row.
				new_display.html("&nbsp;");
				buttons.hide();
				play_button.css("display", "inline-block");
				return;
			}

			// Show the focus selected in the edit modal.
			new_display.html(
				focusValueTpl({
					new: true,
					focus_parent: new_parent.get("name"),
					focus_parent_type: new_parent.model_type,
					focus_topic: new_topic.get("name"),
					focus_topic_type: new_topic.model_type,
				})
			);
			// In case alc-one-line clips the text, have a tooltip.
			new_display.attr("title", new_display.text().replace(/\s+/g, " "));

			// Substitute for jquery's show, which breaks things here
			buttons.css("display", "inline-block");
		},

		onDropdownSelect: function (parent_model) {
			var changed = this.setShownParentModel(parent_model);
			if (!changed) {
				return;
			}

			if (this.is_tutorial) {
				(function () {
					var topic_model = parent_model.get("topics").at(0);
					this.topic_model = topic_model;
					this.is_tutorial = false;
					this.createDropdownSubview();
					this.showTable();
					this.render();

					this.updateDisplays({end_of_tutorial: true});
					var focus_data = this.model.getFocusAsObject(
						topic_model,
						parent_model
					);
					this.model.changeFocus(
						focus_data,
						function (ok, data) {
							if (!ok) {
								AlcVBase.showModalError(
									"Your focus was not set successfully.",
									data
								);
							}
						},
						{allow_filter: true}
					);
				}).call(this);
			} else {
				this.render();
			}
		},

		onRowSelect: function (topic_model, parent_model) {
			this.topic_model = topic_model;
			this.updateDisplays();
		},

		onSaveClick: function () {
			this.onSetFocus(this.topic_model, this.parent_model);
		},

		onSetFocus: function (topic_model, parent_model) {
			if (!topic_model) {
				return;
			}
			var focus_data = this.model.getFocusAsObject(topic_model, parent_model);

			this.model.changeFocus(
				focus_data,
				function (ok, data) {
					if (!ok) {
						AlcVBase.showModalError(
							"Your focus was not set successfully.",
							data
						);
					}
				},
				{allow_filter: true}
			);
			Modal.closeAllModals();
		},

		getContext: function () {
			return {
				is_advanced: !!this.advanced_from_topic,
			};
		},

		postRender: function () {
			// This will dip down into the progress table view and rebuild the
			// scrollbar, fixing some weird bug where redisplaying a view makes
			// the scrollbar not appear.
			if (this.$(".aops-scroll-outer").length) {
				AlcVBase.buildScrollbar(this.$el);
			}
			this.updateDisplays();
			AoPS.Ui.Modal.fitMasks();

			this.$(".alc-set-focus-button").click(_.bind(this.onSaveClick, this));
			this.$(".alc-cancel-button, .alc-play-button").click(function () {
				Modal.closeAllModals();
			});
		},

		onClose: function () {
			AlcVBase.BaseView.prototype.onClose.apply(this);
			Modal.closeAllModals();
		},
	});

	AlcVFocus.EditorAllDisplay = AlcVBase.BaseView.extend({
		initialize: function (options) {
			// No template
			this.$el.addClass("alc-edit-focus-all-display");
			this.$el.text("");
			// this.$el.text('All Topics blurb');
		},
	});

	return AlcVFocus;
})(AoPS.Alcumus.Views.Focus);
